import { SaleChannelsStateInterface } from '.';

function state(): SaleChannelsStateInterface {
  return {
    saleChannels: [],
  };
}

export default state;
